// Role-based permissions configuration
// Each role has: read (can see), write (can create/edit), modules (accessible sidebar items)

const DEFAULT_PERMISSIONS = {
  admin: {
    label: "Admin",
    description: "Acesso total ao sistema",
    modules: ["dashboard", "customers", "products", "sales", "subscriptions", "payments", "chat", "operators", "audit"],
    read: ["all"],
    write: ["all"],
  },
  operator: {
    label: "Operador",
    description: "Clientes, produtos e vendas",
    modules: ["dashboard", "customers", "products", "sales", "chat", "operators"],
    read: ["customers", "products", "sales", "chat", "operators"],
    write: ["customers", "products", "sales", "chat"],
  },
  finance: {
    label: "Financeiro",
    description: "Assinaturas, pagamentos e relatórios",
    modules: ["dashboard", "subscriptions", "payments", "customers", "operators"],
    read: ["customers", "subscriptions", "payments", "operators"],
    write: ["payments", "subscriptions"],
  },
  support: {
    label: "Suporte",
    description: "Chat e suporte ao cliente",
    modules: ["dashboard", "chat", "customers", "operators"],
    read: ["customers", "chat", "operators"],
    write: ["chat"],
  },
};

// Module key to sidebar path mapping
const MODULE_PATHS = {
  dashboard: "/crm",
  customers: "/crm/customers",
  products: "/crm/products",
  sales: "/crm/sales",
  subscriptions: "/crm/subscriptions",
  payments: "/crm/payments",
  chat: "/crm/chat",
  operators: "/crm/operators",
  audit: "/crm/audit",
};

export function getPermissions(role) {
  return DEFAULT_PERMISSIONS[role] || DEFAULT_PERMISSIONS.operator;
}

export function canAccessModule(role, moduleKey) {
  if (role === "admin") return true;
  const perms = getPermissions(role);
  return perms.modules.includes(moduleKey);
}

export function canRead(role, moduleKey) {
  if (role === "admin") return true;
  const perms = getPermissions(role);
  return perms.read.includes("all") || perms.read.includes(moduleKey);
}

export function canWrite(role, moduleKey) {
  if (role === "admin") return true;
  const perms = getPermissions(role);
  return perms.write.includes("all") || perms.write.includes(moduleKey);
}

export function getAllRoles() {
  return Object.entries(DEFAULT_PERMISSIONS).map(([key, val]) => ({
    key,
    label: val.label,
    description: val.description,
    modules: val.modules,
    read: val.read,
    write: val.write,
  }));
}

export { DEFAULT_PERMISSIONS, MODULE_PATHS };
